(function () {
    if (globalThis.__mothersSale2026ScriptBundleLoaded) {
        return;
    }
    globalThis.__mothersSale2026ScriptBundleLoaded = true;

/**
 * 全局隐藏、不应由脚本自动点击的 swatch（与 CSS 中 data*=/data-id 规则对齐）。
 * - dataContains：匹配 swatch 的 `data` 属性，任一子串命中即排除。
 * - dataIds：匹配 `data-id`，与字符串相等即排除。
 */
let SWATCH_AUTO_CLICK_BLOCKLIST = {
    dataContains: [
        'Kipchoge Co-branded Edition',
        /* 含「Boston Marathon® Co-branded Edition / Standard」等变体 */
        // 'Boston Marathon® Co-branded Edition',
    ],
    dataIds: []
};

let SWATCH_AUTO_CLICK_BLOCKLIST_ID_SET = new Set(SWATCH_AUTO_CLICK_BLOCKLIST.dataIds.map(String));

/**
 * 页面加载时默认选中的变体：对应 swatch 的 `data-id`（Shopify variant id）。
 * 填多个则依次触发；同一 id 在 DOM 中出现多次（多块商品卡）会对每个节点各点一次。
 */
let DEFAULT_SWATCH_VARIANT_DATA_IDS = ['44043747819720', '44598524543176', '44758320742600'];

/**
 * @param {JQuery} $swatch
 * @returns {boolean} true 表示不应自动 trigger click
 */
function isSwatchAutoClickBlocked ($swatch) {
    const idAttr = $swatch.attr('data-id');
    if (idAttr != null && idAttr !== '' && SWATCH_AUTO_CLICK_BLOCKLIST_ID_SET.has(String(idAttr))) {
        return true;
    }
    const dataAttr = $swatch.attr('data') || '';
    for (const fragment of SWATCH_AUTO_CLICK_BLOCKLIST.dataContains) {
        if (dataAttr.includes(fragment)) {
            return true;
        }
    }
    return false;
}

/**
 * 在候选集合中按 DOM 顺序对第一个未排除的 swatch 触发 click。
 * @param {JQuery} $candidates
 */
function triggerFirstAllowedSwatchClick ($candidates) {
    $candidates.each(function () {
        const $s = $(this);
        if (!isSwatchAutoClickBlocked($s)) {
            $s.trigger('click');
            return false;
        }
    });
}

/**
 * @param {JQuery} [$root] — 限定范围；省略则整页（与历史行为一致）。
 */
function getMothersSaleScope ($root) {
    return $root?.length ? $root : $(document);
}

/**
 * Mothers sale best section: sync mobile config layer + desktop + mini variant images by variant id.
 * @param {JQuery} $productItem — `.product_item` within `.mothers-sale-best`
 * @param {string|number} variantId — Shopify variant id (swatch `data-id`)
 */
function activateMothersSaleBestVariantVisuals ($productItem, variantId) {
    const vid = String(variantId);
    const $cfgMatch = $productItem.find(
        `.mothers-sale-best__mobile-primary-config .mothers-sale-best__mobile-config-img[data-id='${vid}']`
    );
    if ($cfgMatch.length) {
        $cfgMatch.first().addClass('active').siblings('.mothers-sale-best__mobile-config-img').removeClass('active');
    }
    $productItem.find(`.mothers-sale-best__variant-media--desktop .variant-image[data-id='${vid}']`).each(function () {
        const $el = $(this);
        $el.addClass('active').siblings('.variant-image').removeClass('active');
    });
    $productItem.find(`.mini-product-img-link .variant-image[data-id='${vid}']`).each(function () {
        const $el = $(this);
        $el.addClass('active').siblings('.variant-image').removeClass('active');
    });
}

/**
 * 按 `DEFAULT_SWATCH_VARIANT_DATA_IDS` 对对应 swatch 触发 click（尊重 SWATCH_AUTO_CLICK_BLOCKLIST）。
 * @param {JQuery} [$root]
 */
function applyDefaultSwatchSelections ($root) {
    const $scope = getMothersSaleScope($root);
    for (const rawId of DEFAULT_SWATCH_VARIANT_DATA_IDS) {
        const id = String(rawId);
        $scope.find(`.product-color-swatch-wrapper .swatch[data-id='${id}']`).each(function () {
            const $swatch = $(this);
            if (!isSwatchAutoClickBlocked($swatch)) {
                $swatch.trigger('click');
            }
        });
    }
}

/**
 * 切换「第一套 / 第二套」颜色区、标题、折扣、主图、价格列表展示（eq(0) vs eq(1)）。
 * @param {JQuery} productItem
 * @param {JQuery} productBox
 * @param {boolean} secondActive — true 对应 custom-item 分支
 */
function setDualSlotMode (productItem, productBox, secondActive) {
    const $pci0 = productItem.find('.product_color_item').eq(0);
    const $pci1 = productItem.find('.product_color_item').eq(1);
    const $title0 = productItem.find('.product-title').eq(0);
    const $title1 = productItem.find('.product-title').eq(1);
    const $disc0 = productItem.find('.discount').eq(0);
    const $disc1 = productItem.find('.discount').eq(1);
    const $img0 = productBox.find('.variant-img-content').eq(0);
    const $img1 = productBox.find('.variant-img-content').eq(1);
    const $price0 = productBox.find('.price_list').eq(0);
    const $price1 = productBox.find('.price_list').eq(1);

    if (secondActive) {
        $pci0.removeClass('active').addClass('hidden');
        $pci1.addClass('active').removeClass('hidden');
        $title0.addClass('hidden');
        $title1.removeClass('hidden');
        $disc0.addClass('hidden');
        $disc1.removeClass('hidden');
        $img0.addClass('hidden');
        $img1.removeClass('hidden');
        $price0.addClass('hidden').removeClass('active');
        $price1.removeClass('hidden').addClass('active');
    } else {
        $pci1.removeClass('active').addClass('hidden');
        $pci0.addClass('active').removeClass('hidden');
        $title1.addClass('hidden');
        $title0.removeClass('hidden');
        $disc1.addClass('hidden');
        $disc0.removeClass('hidden');
        $img1.addClass('hidden');
        $img0.removeClass('hidden');
        $price1.addClass('hidden');
        $price0.removeClass('hidden').addClass('active');
    }
}

/**
 * 根据非 active 的 variant 项隐藏对应 swatch（与历史整页逻辑一致，可传入 $root 限定范围）。
 * @param {JQuery} [$root]
 */
function showHideColor ($root) {
    const $scope = getMothersSaleScope($root);
    $scope.find('.product-color-swatch-wrapper .swatch').removeClass('hidden');
    $scope.find('.variant_list .variant_item .item:not(.active)').each(function () {
        const htmlContent = $(this).attr('data');
        $(this).parents('.variant_list').find(`.swatch[data*='${htmlContent}']`).addClass('hidden');
    });
}

/**
 * Swiper 等替换 DOM 后由 section 触发：`detail.root` 为容器元素（如 `.mothers-sale-more`）。
 */
function initMothersSale2026ProductCardBehavior ($root) {
    showHideColor($root);
    applyDefaultSwatchSelections($root);
}

document.addEventListener('DOMContentLoaded', function () {
    if (!globalThis.__mothersSale2026DelegatedBound) {
        globalThis.__mothersSale2026DelegatedBound = true;

        $(document.body).on('click.mothersSale2026', '.product-color-swatch-wrapper .swatch', function () {
            const $swatch = $(this);
            const $productItem = $swatch.parents('.product_item');

            $swatch.addClass('active').siblings().removeClass('active');

            const variantId = $swatch.data('id');
            const variantSku = $swatch.data('sku');
            const available = $swatch.data('varavailable');

            $productItem
                .find('.price_list')
                .find(`.price[data-id=${variantId}]`)
                .addClass('active')
                .siblings()
                .removeClass('active');

            if ($productItem.closest('.mothers-sale-best').length) {
                activateMothersSaleBestVariantVisuals($productItem, variantId);
            } else {
                $productItem
                    .find(`.variant-image[data-id='${variantId}']`)
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
            }

            const $cartBtns = $productItem.find('.addtocart');
            $cartBtns.attr('data-variant-id', variantId);

            if (available) {
                $cartBtns.removeClass('disabled');
                $cartBtns.text('Add to Cart');
            } else {
                $cartBtns.addClass('disabled');
                $cartBtns.text('Sold Out');
            }

            $swatch.parents('.buy-card').find('.product-item.product_info').attr('data-sku', variantSku);

            const discountEl = $productItem.find('.discount').eq(0).find('span')
            if(variantId == '44526682898632' || variantId == '44598506422472') {
                $(discountEl).text('Limited Edition')
            } else {
                $(discountEl).text($productItem.find('.product-item').data('discount')) 
            }
        });

        $(document.body).on('click.mothersSale2026', '.variant_list .variant_item .item', function () {
            const $item = $(this);
            if ($item.hasClass('active')) {
                return;
            }

            $item.addClass('active').siblings().removeClass('active');

            const itemData = $item.attr('data');
            const $productItem = $item.parents('.product_item');
            const $productBox = $item.parents('.product-box');

            if (itemData === 'custom-item') {
                $productItem.find('.corner-marker').hide();
                $productItem.find('a').attr('href', $item.data('url'));
                setDualSlotMode($productItem, $productBox, true);

                setTimeout(() => {
                    triggerFirstAllowedSwatchClick(
                        $productItem.find('.product_color_item.active .product-color-swatch-wrapper .swatch')
                    );
                    if ($productItem.hasClass('openfit2plus')) {
                        $productItem.find('.variant_item').find('.item.active').text('USB-C');
                    }
                }, 20);
                return;
            }

            if ($productItem.find('.product_color_item').length > 1) {
                $productItem.find('.corner-marker').show();
                $productItem.find('a').attr('href', $item.parents('.product_info').data('url'));
                $productItem.find('.square').show();
                setDualSlotMode($productItem, $productBox, false);
            }

            if ($productItem.hasClass('openfit2plus')) {
                $productItem.find('.variant_item').find('.item.active').text('USB-C + Wireless Charging');
            }

            if (itemData === 'No Adapter') {
                $productItem.find('.square').hide();
            } else {
                $productItem.find('.square').show();
            }

            if ($productItem.hasClass('openmeet')) {
                const discountText = itemData === 'No Adapter' ? '30% OFF' : '25% OFF';
                $productItem.find('.discount').find('span').text(discountText);
            }

            setTimeout(() => {
                showHideColor();
                triggerFirstAllowedSwatchClick(
                    $productItem.find(
                        '.product_color_item.active .product-color-swatch-wrapper .swatch:not(.hidden)'
                    )
                );
            }, 20);
        });
    }

    initMothersSale2026ProductCardBehavior();

    document.addEventListener('mothers-sale-2026:content-updated', function (e) {
        const root = e?.detail?.root;
        const $root = root ? $(root) : null;
        initMothersSale2026ProductCardBehavior($root);
    });

    $('.bottom_item .bottom_cart .add_btn, .slide_card .slide_bottom .add_btn').on('click', function () {
        $(this).parents('.bottom_item').find('add-cart-button').eq(0).trigger('click');
    });
});

})();
